import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UploadDropzoneBorderComponent } from '../upload-dropzone-border/upload-dropzone-border.component';
import { FilesizePipe } from '../../../file-size/pipes/file-size.pipe';

@Component({
  selector: 'app-upload-dropzone',
  imports: [FilesizePipe, UploadDropzoneBorderComponent],
  templateUrl: './upload-dropzone.component.html',
  styleUrl: './upload-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDropzoneComponent {
  public readonly maxFileSize = input.required<number>();
  public readonly maxNumberOfFiles = input<number>(0);
}
